import React from "react";
import * as Icons from "lucide-react";

function IconRender({ name, className }) {
  const C = Icons[name] || Icons.Sparkles;
  return <C className={className} />;
}

export default function AboutSection({ about }) {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#f5ebd6]">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-[12px] tracking-tight-wide text-[#a08862] font-semibold">
          {about.eyebrow}
        </p>
        <h2 className="font-serif-display text-4xl md:text-6xl text-[#2a2a2a] mt-4">
          {about.title}
        </h2>
        <div className="divider-line" />
        <div
          className="max-w-3xl mx-auto text-[15px] md:text-base leading-[1.9] text-[#3a3a3a] mt-6 rich-text"
          dangerouslySetInnerHTML={{ __html: about.description || "" }}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {about.features.map((f, i) => (
            <div
              key={i}
              className="bg-[#ecdfc4] p-8 text-center transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex justify-center mb-4">
                <IconRender
                  name={f.icon}
                  className="w-10 h-10 text-[#a08862]"
                />
              </div>
              <h3 className="font-serif-display text-2xl text-[#2a2a2a] mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-[#5a5a5a] leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
